import type Store from "@ember-data/store";
import Helper from "@ember/component/helper";
import { service } from "@ember/service";
import { htmlSafe } from "@ember/template";
import type { SafeString } from "@ember/template/-private/handlebars";
import FileTypeFromMimeType from "parog-web/helpers/file-type-from-mime-type";
import type BioExamResultsReceivedJournalEvent from "parog-web/models/bio-exam-results-received-journal-event";
import type FileAttachment from "parog-web/models/file-attachment";

type Positional = Array<BioExamResultsReceivedJournalEvent>;

export interface FileAttachmentsDescSignature {
  Args: {
    Positional: Positional;
  };
  Return: SafeString;
}

type CountPerType = { [k: string]: number };

export default class FileAttachmentsDescHelper extends Helper<FileAttachmentsDescSignature> {
  @service intl;
  @service declare store: Store;

  override compute([je]: Positional): SafeString {
    const helper = new FileTypeFromMimeType();
    const countPerType = je.fileAttachmentsWithoutZip.reduce(
      (acc: CountPerType, curr: FileAttachment) => {
        const type = helper.compute([curr.mimeType]);
        if (!type) return acc;

        if (!acc[type]) {
          acc[type] = 0;
        }

        acc[type] += 1;
        return acc;
      },
      {}
    );

    if (je.isFromHprim) {
      countPerType["HPRIM"] = je.apicryptMessageReceivedJournalEvents.length;
    }

    return this.counterToString(countPerType);
  }

  counterToString(countPerType: CountPerType): SafeString {
    let str = "";
    const keysArray = Object.keys(countPerType);
    keysArray.forEach((key, index) => {
      str += this.intl.t(`bioExamResultCodes.fileAttachments.${key}`, {
        count: countPerType[key]
      });

      if (index < keysArray.length - 1) {
        str += "<br />";
      }
    });
    return htmlSafe(str);
  }
}
